import { AuthState } from '@aws-amplify/ui-components';
import { Box, Button, Image, Text, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';

import { SignInModal } from '~/components/organisms';
import { useUser } from '~/containers';
import mainImage from './rikei_match_header.png';

const TopAd: React.FC = () => {
  const { user, loading } = useUser();
  const [open, setOpen] = useState(!user);
  const onClose = () => {
    setOpen(false);
  };

  return !loading && user ? (
    <Box height={700} />
  ) : (
    <Box p={10}>
      <VStack alignItems="center">
        <Image src={mainImage} />
        <Box px={[4, 0]}>
          <Text mt={1} fontSize="lg" align="center">
            「学歴よりも学生時代の努力を見てほしい」「思いがけない会社と出会いたい」
          </Text>
        </Box>
        <Box px={[4, 0]}>
          <Text mt={1} fontSize="lg" align="center">
            リケイマッチは、そんな想いの理系学部生に向けた逆求人型の就活サイトです。
          </Text>
          <Text mt={1} fontSize="lg" align="center">
            プロフィール登録した後は待つだけで、IT企業やメーカーの非公開求人やインターンのお誘いがスカウトメールで届きます。
          </Text>
        </Box>
        <Box px={[4, 0]}>
          <Text mt={1} fontSize="lg" align="center">
            情報収集、冬のインターン、本選考に向けて準備をしたい理系学生の方々は、ぜひ登録してみてください！
          </Text>
        </Box>
        <Button
          color="white"
          bg="pink.400"
          onClick={() => {
            setOpen(true);
          }}
        >
          ユーザー登録する
        </Button>
        <Box px={[4, 0]}>
          <SignInModal
            isOpen={open}
            onClose={onClose}
            defaultAuthState={AuthState.SignUp}
          />
        </Box>
      </VStack>
    </Box>
  );
};

export default TopAd;
